module.exports = __webpack_public_path__ + "static/media/mmc-logo.983ab7b2.png";